import { render } from "./day-grid-button.vue?vue&type=template&id=4e18ac2c&ts=true"
import script from "./day-grid-button.vue?vue&type=script&lang=ts"
export * from "./day-grid-button.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__